<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 sm6>
                <v-select
                        :label="this.$i18n.t('site.searchBoxes.enterFellowshipName')"
                        autocomplete
                        :loading="loading"
                        item-text="fellowship"
                        chips
                        :items="items"
                        :rules="[() => select.length > 0 || this.$i18n.t('site.searchBoxes.instructions') ]"
                        :search-input.sync="search"
                        v-model="select"
                        append-icon="search"
                >
                    <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                            <v-list-tile-title v-html="data.item.fellowship"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="(data.item.fellowship) + ', ' + data.item.serverName + ', ' + data.item.currScore"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </template>
                </v-select>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import _ from 'lodash';
    let elvenStats = require('../lib/elven-stats');
    import axios from 'axios';
    export default {
        name: "elv-fellowship-search-box",
        data () {
            return {
                loading: false,
                items: [],
                search: null,
                select: [],
            }
        },
        watch: {
            search (val) {
                val && this.querySelections(val)
            },
            select(val) {
                console.log("Select modified!", val);
                this.$ga.event('FellowshipSearch', 'Selected', "", "");
                this.$router.push({ name: 'FellowshipDetail',
                                    params: { server: val.server, fellowshipId: val.fellowshipId }});

            }
        },
        methods: {
            querySelections (v) {
                this.loading = true
                let self = this;
                axios.get(`/api/search`, { params: { q: v} }).then( function(response) {
                    //console.log(JSON.stringify(response.data) );
                    _.each(response.data, function(item) {
                        item.serverName = elvenStats.mapDomainAndServerName(item.server);
                    });
                    self.items = response.data;
                    self.loading = false;
                    self.$ga.event('FellowshipSearch', 'Queried', "", "");
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ElvFellowshipSearchBox.vue